import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, MapPin, Clock } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function Footer({ brand = "stamp" }) {
  const { settings } = useSite();
  if (!settings) return null;

  const ig = brand === "sports" ? settings.sports_instagram : settings.stamp_instagram;
  const fb = brand === "sports" ? settings.sports_facebook : settings.stamp_facebook;
  const email = settings.contact_email;

  return (
    <footer className="border-t border-[var(--border)] bg-[var(--bg-secondary)] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="font-head font-extrabold text-xl mb-3">
              {brand === "sports" ? "K8 Sports" : "K8 Stamp"}
            </h3>
            <p className="text-sm text-[var(--text-muted)] max-w-xs">
              {brand === "sports"
                ? "Uniformes esportivos personalizados para times, escolas e interclasse."
                : "Uniformes, camisetas, brindes e materiais gráficos para empresas e eventos."}
            </p>
          </div>

          <div className="space-y-2 text-sm text-[var(--text-muted)]">
            {settings.company_name && (
              <p className="font-semibold text-[var(--text-main)]">{settings.company_name}</p>
            )}
            {settings.company_address && (
              <p className="flex items-start gap-2">
                <MapPin size={15} className="mt-0.5 shrink-0" /> {settings.company_address}
              </p>
            )}
            {settings.company_hours && (
              <p className="flex items-start gap-2">
                <Clock size={15} className="mt-0.5 shrink-0" /> {settings.company_hours}
              </p>
            )}
            {email && (
              <a href={`mailto:${email}`} className="flex items-center gap-2 hover:text-[var(--text-main)]">
                <Mail size={15} /> {email}
              </a>
            )}
          </div>

          <div>
            <div className="flex gap-3 mb-4">
              {ig && (
                <a
                  href={ig}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram"
                  className="p-2.5 rounded-full border border-[var(--border)] hover:border-[var(--accent)] transition-colors"
                >
                  <Instagram size={18} />
                </a>
              )}
              {fb && (
                <a
                  href={fb}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-facebook"
                  className="p-2.5 rounded-full border border-[var(--border)] hover:border-[var(--accent)] transition-colors"
                >
                  <Facebook size={18} />
                </a>
              )}
            </div>
            <div className="flex flex-col gap-1 text-sm text-[var(--text-muted)]">
              <Link to="/" className="hover:text-[var(--text-main)]">K8 Stamp</Link>
              <Link to="/k8-sports" className="hover:text-[var(--text-main)]">K8 Sports</Link>
              {settings.campaign_open && (
                <Link to="/pagode-das-cinco-pontas" className="hover:text-[var(--text-main)]">
                  Loja Pagode das Cinco Pontas
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[var(--border)] text-xs text-[var(--text-muted)] flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {settings.company_name || "K8"}. Todos os direitos reservados.</span>
          <Link to="/admin" className="hover:text-[var(--text-main)]">Painel administrativo</Link>
        </div>
      </div>
    </footer>
  );
}
